// js
import Engagement from '../../components/analytics/Engagement';
import { connect } from 'react-redux';
import { createEngagementItem, updateEngagementItem, deleteEngagementItem } from '../../actions/engagementItemActions';


const mapStateToProps = state => {
  return {
    engagementItems: state.dsa.engagementItems
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    makeCreateEngagementItem: (category) => (
      (name, details) => (
        dispatch(createEngagementItem(ownProps.dsa.dsa.id, category, name, details))
      )
    ),
    updateEngagementItem: (id, name, details) => (
      dispatch(updateEngagementItem(id, ownProps.dsa.id, name, details))
    ),
    deleteEngagementItem: (id) => (
      dispatch(deleteEngagementItem(id))
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Engagement);



// WEBPACK FOOTER //
// ./src/containers/analytics/Engagement.js